import home from './home';
import center from './center';
import login from './login';
import user from './user';
import order from './order';

export default {
  home,
  center,
  user,
  order,
  login,
};



// WEBPACK FOOTER //
// ./src/api/index.js